module.exports = __webpack_public_path__ + "img/vecdyn_logo.dea94f09.svg";